module.exports = __webpack_public_path__ + "img/planning_and_current.c7d566e0.png";